import { spawn } from 'redux-saga/effects';

import { sagas as listSagas } from './listModule';
import { sagas as updateSagas } from './updateModule';

export default function* contactSagas() {
	yield spawn(listSagas);
	yield spawn(updateSagas);
}
